import { SvgIconModule } from '@toro/common/shared/components';
import { AccountTypeComponent } from './account-type.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
    AccountTypeComponent,
  ],
  imports: [
    CommonModule,
    SvgIconModule,
  ],
  exports: [
    AccountTypeComponent,
  ],
})
export class AccountTypeModule { }
